import '../styles/AddWords.css';
import React,{ useState, useEffect } from 'react';
import z from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

export default function AddWords({
  project, 
  updateProject
}){
  const today = new Date().toISOString().split("T")[0];
  const [vh, setVh] = useState(window.innerHeight);

useEffect(() => {
  const handleResize = () => setVh(window.innerHeight);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

const schema = z.object({
  newWords: z
  .number("Liczba słów jest wymagana")
  .int("Liczba słów nie może być liczbą niecałkowitą")
  .positive("Liczba słów nie może być ujemna"),

  dateWords: z
  .string()
  .refine((val) => !isNaN(Date.parse(val)),
  "Nieprawidłowa data")
  .refine((val) => val <= new Date().toISOString().split("T")[0],
  "Umiesz przewidywać przyszłość? 🤨"),

  variant: z
  .enum(["add", "set"],  {
    required_error: "Wybierz wariant",
    invalid_type_error: "Nieprawidłowy wariant"
  }),

  chapter: z
  .string()
  .optional()
});

const {
  register,
  handleSubmit,
  formState: { errors }, trigger } = useForm({
  resolver: zodResolver(schema),
});

const addWords= async(formData)=>{
        const valid = await trigger(); 
        if (!valid) return; 
        const kopia = {...project};
        const data = formData.dateWords;
        const newWords = Number(formData.newWords);
        const Variant = formData.variant;
        let wordsCount;
        if(Variant == 'add'){
          wordsCount = newWords;
        } else if (Variant == 'set')  {
          const AllWords = kopia.actualwords;
          wordsCount = newWords - AllWords;
          
        }
        if(data <= today){
          kopia.actualwords += wordsCount;
          const existingEntry = kopia.history.find(entry => entry.date == data );
          if(existingEntry){
            existingEntry.words += wordsCount;
          }
          else{
            kopia.history.push ({
            date: data,
            words: wordsCount
          });
          }
          kopia.history.sort((a, b) => new Date(a.date) - new Date(b.date));
          updateProject(kopia);

          //Dodawanie do rozdziałów
          if(project?.settings.chaptersEnabled) {
            const chapterid = formData.chapter;
            const chapter = kopia.chapters.find(a => a.chapterID == chapterid);
            if(chapter){
              chapter.words += wordsCount;
            }
          }
        } 
  }
    return(
        <div className='AddWordsSite'
        style = {{ height: `${vh - 70}px` }}> 
            
                <form onSubmit={handleSubmit(addWords)} className='AddWordsForm'> 
                    <input 
                      type = "number"
                      className='FormInput' 
                      placeholder='Liczba słów'
                      {...register("newWords", {setValueAs: v => parseInt(v)})}/>

                    {errors.newWords && (
                      <p className="error">{errors.newWords.message}</p>
                    )}

                    <input 
                      type = "date" 
                      className='FormInput' 
                      defaultValue = {today} 
                      {...register("dateWords")}/>

                    {errors.dateWords && (
                      <p className="error">{errors.dateWords.message}</p>
                    )}

                    <select className='FormInput' {...register("variant")}> 
                        <option value='add'> Nowe słowa </option>
                        <option value='set'> Cały projekt </option>
                    </select>

                    {errors.variant && (
                      <p className="error">{errors.variant.message}</p>
                    )}

                    {project?.settings.chaptersEnabled && (
                        <select name="chapter" className='FormInput' {...register("chapter")}>
                        {project?.chapters.map((chapter, i) => (
                            <option key={i} value={chapter.chapterID}> {chapter.title} </option>
                        ))}
                        </select>
                    )}
                    {errors.chapter && (
                      <p className="error">{errors.chapter.message}</p>
                    )}
                    <button className='AddWordsButton'> Dodaj słowa </button>
                </form>
        </div>
    )
}